import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './home/HomePage';
import RootLayout from './RootLayout';
import AboutPage from './about/AboutPage';

function AppRoutes({ children }) {
  return (
    <Router>
      <RootLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </RootLayout>
    </Router>
  );
}

export default AppRoutes;
